import { render, staticRenderFns } from "./BesoinAccidentDeces.vue?vue&type=template&id=8f88eec6&scoped=true&"
import script from "./BesoinAccidentDeces.vue?vue&type=script&lang=js&"
export * from "./BesoinAccidentDeces.vue?vue&type=script&lang=js&"
import style1 from "./BesoinAccidentDeces.vue?vue&type=style&index=1&id=8f88eec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f88eec6",
  null
  
)

export default component.exports